import React from 'react';

export const NoResults = () => (
    <div className="no-results">
        Sorry, no results found. To display more packages, try selecting fewer
        filters or adjusting your search term.
    </div>
);
